
import React from "react";
import {Route, Routes} from "react-router-dom";
import Home from "./pages/home";
import DefaultLayout from "./layouts/DefaultLayout";
import Projects from "./pages/projects";
import Skills from "./pages/skills";

function Router() {
    return (
       <Routes>
           <Route path="/" element={<DefaultLayout/>}>
               <Route index element={<Home/>}/>
               <Route path="/projects" element={<Projects/>}/>
               <Route path="/skills" element={<Skills/>}/>
           </Route>
       </Routes>
    );
}

export default Router as React.FC;
